import { render } from "./WCLanguagesMenu.vue?vue&type=template&id=0e6e830c&scoped=true"
import script from "./WCLanguagesMenu.vue?vue&type=script&lang=js"
export * from "./WCLanguagesMenu.vue?vue&type=script&lang=js"

import "./WCLanguagesMenu.vue?vue&type=style&index=0&id=0e6e830c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6e830c"]])

export default __exports__